export default {
  userHasSubscription(state) {
    return (
      state.currentUser &&
      (state.currentUser.hasActiveSubscription ||
        (state.currentUser.info && state.currentUser.info.companyHasActiveSubscription))
    );
  },
};



// WEBPACK FOOTER //
// ./src/store/getters.js